import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { Fluid } from 'primeng/fluid';
import { CategorySumsubConfig } from '@/lib-backend';

/** Reusable, presentation-only editor for a CategorySumsubConfig. */
@Component({
    selector: 'app-category-sumsub-form',
    standalone: true,
    imports: [FormsModule, InputText, Fluid],
    templateUrl: './category-sumsub-form.html',
})
export class CategorySumsubForm {
    readonly value = model.required<CategorySumsubConfig>();
    readonly disabled = input<boolean>(false);

    protected setField<K extends keyof CategorySumsubConfig>(field: K, v: CategorySumsubConfig[K]): void {
        this.value.update(d => ({ ...d, [field]: v }));
    }
}
